(function () {
  'use strict';

  angular
    .module('flightInformationReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightInformationReport', {
        url: '/flight-information-report',
        templateUrl: 'flight-information-report/views/flight-information-report.tpl.html',
        controller: 'FlightInformationReportCtrl',
        controllerAs: 'flightInformationReport'
               
     });
  }
}());
